export default __webpack_public_path__ + "static/media/map-marker-hover.35517d80.svg";